function initPrintable() {
    document.addEventListener( 'click', ( event: Event ) => {
        if ( !event.target || !( event.target instanceof HTMLElement ) ) {
            return;
        }

        if ( ( !event.target.parentElement || !event.target.parentElement.classList.contains( 'print-page' ) ) &&
             ( !event.target || !event.target.classList.contains( 'print-page' ) ) ) {
            return;
        }

        window.print();
    } );
}

export default initPrintable;
